module.exports = __webpack_public_path__ + "img/neck-ectomorph-female.a18418d3.svg";